import React from "react";
import { ShareApplicationPerson } from "@/types/ShareApplication";
import { CopyUrlComponent } from "../CopyUrlComponent";
import "./LinkedAccountComponent.scss";

export interface LinkedAccountComponentProps {
  person: ShareApplicationPerson;
  financialApplicationId?: string;
}

export const LinkedAccountComponent: React.FC<LinkedAccountComponentProps> = ({
  person,
  financialApplicationId: _,
}) => {
  // Generate the share URL for the linked account
  const generateShareUrl = () => {
    // This would typically come from an API or be constructed based on your routing
    // For now, using a placeholder URL
    const baseUrl = window.location.origin;
    return `${baseUrl}/customer/portal`;
  };

  return (
    <div className="linked-account-component">
      <h3>Share Application with {person.fullName}</h3>
      <p>This person already has access to the application. You can share the direct link below.</p>

      <CopyUrlComponent
        url={generateShareUrl()}
        label="Application Share Link"
        description="Copy this link to share the application directly with the person"
      />
    </div>
  );
};

export default LinkedAccountComponent;
